const selectedVariants = {};
const MOBILE_BREAKPOINT = 990;
const moneyFormatters = new Map();
const customScrollbarStates = new WeakMap();
let customScrollbarFrame = null;

function getMoneyFormatter(currency) {
  if (!moneyFormatters.has(currency)) {
    moneyFormatters.set(currency, new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency,
    }));
  }

  return moneyFormatters.get(currency);
}

function formatCardMoney(cents, currencyCode) {
  const currency = currencyCode || window.Shopify?.currency?.active || 'CLP';
  const amount = Number(cents || 0) / 100;

  try {
    return getMoneyFormatter(currency).format(amount);
  } catch (error) {
    return new Intl.NumberFormat('es-CL').format(amount);
  }
}

function updateCustomScrollbars() {
  const sidebar = document.getElementById('mobile-bar');
  if (!sidebar) return;

  if (customScrollbarFrame !== null) return;

  customScrollbarFrame = requestAnimationFrame(() => {
    customScrollbarFrame = null;

    const scrollables = [
      { list: sidebar.querySelector('.app-cart-sidebar__bags-list'), bar: sidebar.querySelector('.custom-scrollbar[data-for="bags-list"]') },
      { list: sidebar.querySelector('.app-cart-sidebar__list'), bar: sidebar.querySelector('.custom-scrollbar[data-for="reco-list"]') }
    ];

    for (const { list, bar } of scrollables) {
      if (!list || !bar) continue;

      const scrollWidth = list.scrollWidth;
      const clientWidth = list.clientWidth;
      const hasScroll = scrollWidth > clientWidth + 1;
      const thumb = bar.querySelector('.custom-scrollbar__thumb');

      if (!thumb) continue;

      let state = customScrollbarStates.get(list);
      if (!state || state.bar !== bar || state.thumb !== thumb) {
        if (state) list.removeEventListener('scroll', state.syncThumb);

        const syncThumb = () => {
          const maxScroll = list.scrollWidth - list.clientWidth;
          if (maxScroll <= 0) return;

          const scrollPercent = list.scrollLeft / maxScroll;
          const trackWidth = bar.clientWidth;
          const thumbWidth = thumb.clientWidth;
          const moveX = scrollPercent * (trackWidth - thumbWidth);

          if (!Number.isNaN(moveX)) {
            thumb.style.transform = `translateX(${moveX}px)`;
          }
        };

        state = { bar, thumb, syncThumb };
        customScrollbarStates.set(list, state);
        list.addEventListener('scroll', syncThumb, { passive: true });
      }

      if (hasScroll) {
        bar.style.setProperty('display', 'block', 'important');
        const visibleRatio = clientWidth / scrollWidth;
        const thumbWidthPercent = Math.max(visibleRatio * 100, 20);
        thumb.style.width = `${thumbWidthPercent}%`;
        state.syncThumb();
      } else {
        bar.style.display = 'none';
        thumb.style.transform = '';
      }
    }
  });
}

// Card Product Carousel Functions
window.cardCarouselNav = function (button, direction) {
  const carousel = button.closest('.card-carousel');
  const slides = [...carousel.querySelectorAll('.card-carousel__slide')].filter(s => getComputedStyle(s).display !== 'none');
  const dots = [...carousel.querySelectorAll('.card-carousel__dot')].filter(d => getComputedStyle(d).display !== 'none');
  const currentIndex = slides.findIndex((s) => s.classList.contains('active'));
  let newIndex;

  if (direction === 'prev') {
    newIndex = currentIndex <= 0 ? slides.length - 1 : currentIndex - 1;
  } else {
    newIndex = currentIndex >= slides.length - 1 ? 0 : currentIndex + 1;
  }

  slides.forEach((s) => s.classList.remove('active'));
  dots.forEach((d) => d.classList.remove('active'));
  slides[newIndex]?.classList.add('active');
  dots[newIndex]?.classList.add('active');
};

window.cardCarouselGoTo = function (dot, index) {
  const carousel = dot.closest('.card-carousel');
  const slides = carousel.querySelectorAll('.card-carousel__slide');
  const dots = carousel.querySelectorAll('.card-carousel__dot');

  slides.forEach((s) => s.classList.remove('active'));
  dots.forEach((d) => d.classList.remove('active'));
  slides[index]?.classList.add('active');
  dots[index]?.classList.add('active');
};

// Swipe support for Card Product Carousel
(function () {
  let startX = 0;
  let startY = 0;
  let isSwipe = false;

  document.addEventListener('touchstart', function (e) {
    const carousel = e.target.closest('.card-carousel');
    if (!carousel) return;
    if (carousel.dataset.cardMediaMode === 'hover') return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isSwipe = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!startX) return;
    const carousel = e.target.closest('.card-carousel');
    if (!carousel) return;
    if (carousel.dataset.cardMediaMode === 'hover') return;

    const diffX = e.touches[0].clientX - startX;
    const diffY = e.touches[0].clientY - startY;

    if (!isSwipe && Math.abs(diffX) > 10 && Math.abs(diffX) > Math.abs(diffY)) {
      isSwipe = true;
    }

    if (isSwipe) {
      if (e.cancelable) e.preventDefault();
    }
  }, { passive: false });

  document.addEventListener('touchend', function (e) {
    if (!startX || !isSwipe) {
      startX = 0;
      return;
    }
    const carousel = e.target.closest('.card-carousel');
    if (!carousel) return;
    if (carousel.dataset.cardMediaMode === 'hover') return;

    const diffX = e.changedTouches[0].clientX - startX;
    if (Math.abs(diffX) > 40) {
      // Inverted: swipe right (diffX > 0) = prev, swipe left (diffX < 0) = next
      window.cardCarouselNav(carousel, diffX > 0 ? 'prev' : 'next');
    }

    startX = 0;
    isSwipe = false;
  }, { passive: true });
})();

window.toggleVariantSelector = function (element) {
  const currentCard = element.closest('.card-product');
  const wasActive = currentCard.classList.contains('mobile-active');

  document.querySelectorAll('.card-product.mobile-active').forEach(card => card.classList.remove('mobile-active'));

  if (!wasActive) currentCard.classList.add('mobile-active');
};

// Cachea tanto solicitudes en curso como productos resueltos para evitar descargas duplicadas.
const productCache = new Map();
const productChangeRequests = new WeakMap();
const CARD_IMAGE_WIDTHS = [165, 360, 500];

function getCardImageUrl(source, width) {
  try {
    const url = new URL(source, window.location.origin);
    url.searchParams.set('width', width);
    return url.toString();
  } catch (error) {
    return source;
  }
}

/**
 * Obtiene los datos de un producto desde Shopify API
 * Usa cache para evitar peticiones repetidas
 */
async function getProductData(handle) {
  if (productCache.has(handle)) return productCache.get(handle);

  const request = fetch(`/products/${handle}.js`)
    .then((response) => {
      if (!response.ok) throw new Error('Product not found');
      return response.json();
    });

  productCache.set(handle, request);

  try {
    return await request;
  } catch (error) {
    productCache.delete(handle);
    console.error('Error fetching product:', error);
    return null;
  }
}

/**
 * Actualiza la tarjeta del producto con los nuevos datos
 */
function updateCard(card, productData) {
  const carousel = card.querySelector('.card-carousel');
  if (!carousel) return;

  const slides = carousel.querySelectorAll('.card-carousel__slide');
  const dots = carousel.querySelectorAll('.card-carousel__dot');

  // Obtener imágenes del producto (hasta 5)
  const images = (productData.media || [])
    .filter((media) => media?.src)
    .slice(0, 5)
    .map((media) => media.src);

  // Actualizar slides del carrusel
  slides.forEach((slide, index) => {
    const img = slide.querySelector('img');
    if (index < images.length && images[index]) {
      if (img) {
        if (!img.sizes) img.sizes = '(max-width: 749px) 180px, 250px';
        img.srcset = CARD_IMAGE_WIDTHS
          .map((width) => `${getCardImageUrl(images[index], width)} ${width}w`)
          .join(', ');
        img.src = getCardImageUrl(images[index], 500);
      }
      slide.style.display = "";
      slide.classList.remove('active');
    } else {
      slide.style.display = "none";
      slide.classList.remove('active');
    }
  });

  // Actualizar dots
  dots.forEach((dot, index) => {
    if (index < images.length) {
      dot.style.display = "";
      dot.classList.remove('active');
    } else {
      dot.style.display = "none";
      dot.classList.remove('active');
    }
  });

  // Activar primer slide y dot
  if (slides[0] && images.length > 0) slides[0].classList.add('active');
  if (dots[0] && images.length > 0) dots[0].classList.add('active');

  // Gestionar visibilidad de navegación
  const navBtns = carousel.querySelectorAll('.card-carousel__btn');
  const dotsContainer = carousel.querySelector('.card-carousel__dots');

  if (images.length > 1) {
    navBtns.forEach(btn => btn.style.display = "");
    if (dotsContainer) dotsContainer.style.display = "";
  } else {
    navBtns.forEach(btn => btn.style.display = "none");
    if (dotsContainer) dotsContainer.style.display = "none";
  }

  // Actualizar título
  const titleH4 = card.querySelector('.card-content h4');
  if (titleH4) {
    titleH4.textContent = productData.title.split(' ').slice(0, 4).join(' ');
  }

  // Actualizar variantes
  const variantsContainer = card.querySelector('.variants');
  if (variantsContainer) {
    variantsContainer.innerHTML = productData.variants.map(v => `
      \u003cdiv class="variant-option ${v.option1 === 'Talla única' ? 'talla-unica' : ''} ${v.option1.includes('-') ? 'range-variant' : ''}" 
           data-variant-id="${v.id}" 
           onclick="selectVariant(this, ${productData.id})" 
           ${!v.available ? 'disabled' : ''}
      >
        ${v.option1 === 'Talla única' ? 'Talla Única' : v.option1.replace(/\s*(meses|años)\s*/gi, (match, word) => word.toLowerCase() === 'meses' ? 'M' : 'A')}
      \u003c/div>
    `).join('');
  }

  // Actualizar precios
  const priceContainer = card.querySelector('.card-price');
  if (priceContainer) {
    const price = productData.price;
    const compareAtPrice = productData.compare_at_price;
    const hasDiscount = compareAtPrice && compareAtPrice > price;

    // Shopify devuelve precios en centavos; formateamos con la moneda activa del storefront.
    const currencyCode = priceContainer.dataset.currencyCode;
    const formattedPrice = formatCardMoney(price, currencyCode);
    const formattedComparePrice = compareAtPrice ? formatCardMoney(compareAtPrice, currencyCode) : null;

    if (hasDiscount) {
      priceContainer.innerHTML = `
        \u003cspan class="price offer">${formattedPrice}\u003c/span>
        \u003cspan class="compare">${formattedComparePrice}\u003c/span>
      `;
    } else {
      priceContainer.innerHTML = `
        \u003cspan class="price">${formattedPrice}\u003c/span>
      `;
    }

    // Actualizar badge de oferta
    const offerBadge = card.querySelector('.badge.offer');
    if (hasDiscount) {
      const discountPercent = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
      if (offerBadge) {
        offerBadge.textContent = `-${discountPercent}%`;
        offerBadge.style.display = '';
      } else {
        const cardHeader = card.querySelector('.card-header');
        if (cardHeader) {
          const newBadge = document.createElement('span');
          newBadge.className = 'badge offer';
          newBadge.textContent = `-${discountPercent}%`;
          cardHeader.insertBefore(newBadge, cardHeader.firstChild);
        }
      }
    } else {
      if (offerBadge) {
        offerBadge.style.display = 'none';
      }
    }
  }

  // Actualizar URL del producto
  const carouselLink = carousel.querySelector('.card-carousel__slides');
  if (carouselLink) {
    carouselLink.href = `/products/${productData.handle}`;
  }

  // Actualizar botón de agregar al carrito
  const addToCartBtn = card.querySelector('.add-to-cart');
  if (addToCartBtn) {
    addToCartBtn.setAttribute('onclick', `addToCart(${productData.id})`);
  }
}

/**
 * Función principal para cambiar de producto
 * Ahora usa AJAX en lugar de data attributes
 */
window.changeProduct = async function (swatch) {
  const card = swatch.closest('.card-product');
  const productHandle = swatch.dataset.productHandle;

  if (!card || !productHandle) {
    console.error('Product handle not found');
    return;
  }

  const requestToken = Symbol(productHandle);
  productChangeRequests.set(card, requestToken);

  // Agregar estado de carga
  card.classList.add('loading');

  try {
    // Obtener datos del producto (con cache)
    const productData = await getProductData(productHandle);

    if (productChangeRequests.get(card) !== requestToken) return;

    if (!productData) {
      console.error('Failed to load product data');
      return;
    }

    // Actualizar la tarjeta con los nuevos datos
    updateCard(card, productData);

    // Actualizar swatches activos
    card.querySelectorAll('.swatch').forEach(s => s.removeAttribute('active'));
    swatch.setAttribute('active', '');

  } catch (error) {
    console.error('Error changing product:', error);
  } finally {
    if (productChangeRequests.get(card) === requestToken) {
      productChangeRequests.delete(card);
      card.classList.remove('loading');
    }
  }
};

async function addToCartAndRefresh(variantId) {
  try {
    const giftWasOpen = document.querySelector('[data-gift-unlock].is-open') != null;

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: "cart-drawer,cart-icon-bubble,cart-icon-bubble-mobile"
      })
    });

    const cartData = await response.json();

    if (!response.ok) {
      console.error('Error al agregar al carrito:', cartData);
      return null;
    }

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartData.sections) {
      cartDrawer.renderContents({ sections: cartData.sections });
    }

    if (giftWasOpen) {
      const giftRoot = document.querySelector('[data-gift-unlock]');
      const giftToggle = giftRoot?.querySelector('.gift-unlock__toggle');
      if (giftRoot && giftToggle) {
        giftRoot.classList.add('is-open');
        giftToggle.setAttribute('aria-expanded', 'true');
      }
    }

    if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'pinflag-custom',
        productVariantId: variantId,
        cartData: cartData
      });
    }

    return cartDrawer;
  } catch (error) {
    console.error('Error al agregar al carrito:', error);
    return null;
  }
}

window.selectVariant = async function (element) {
  if (element.hasAttribute('disabled')) return;

  element.parentElement.querySelectorAll('.variant-option').forEach(v => v.classList.remove('selected'));
  element.classList.add('selected');
  await addToCartAndRefresh(element.dataset.variantId);
};

window.addToCart = async function (productId) {
  const variantId = selectedVariants[productId];
  if (!variantId) return alert('Por favor selecciona una variante');
  await addToCartAndRefresh(variantId);
};

window.scrollCarousel = function (direction, container) {
  const wrapper = container?.querySelector('.cards-wrapper') || document.querySelector('.carousel-container.active .cards-wrapper');
  wrapper?.scrollBy({ left: direction * 410, behavior: 'smooth' });
}

// Función específica para el carrusel de bolsas
window.scrollBagsCarousel = function (direction, bagsContainer) {
  if (bagsContainer) {
    bagsContainer.scrollBy({ left: direction * 410, behavior: 'smooth' });
  }
}

window.toggleCollection = function (collectionId) {
  // This is a legacy function, ideally shouldn't be used with multiple sections
  document.querySelectorAll('.carousel-container, .collection-badges .badge').forEach(el => el.classList.remove('active'));
  document.getElementById(collectionId)?.classList.add('active');
  document.querySelector(`[data-collection-id="${collectionId}"]`)?.classList.add('active');
}

document.addEventListener('change', (e) => {
  if (!e.target.matches('input[type="checkbox"]')) return;
  const form = e.target.closest('form');
  if (!form?.querySelector('input[type="checkbox"]:checked')) return;
  if (form.querySelector('input[name="filter.v.availability"]')) return;
  form.insertAdjacentHTML('beforeend', '<input type="hidden" name="filter.v.availability" value="1">');
});

(() => {
  const handleize = str => str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const recommendationCache = new Map();
  let recommendationRequestId = 0;
  let cartDrawerOpenTimer = null;
  let cartRequest = null;

  const getCart = () => {
    if (cartRequest) return cartRequest;

    cartRequest = fetch('/cart.js')
      .then((response) => {
        if (!response.ok) throw new Error('Cart could not be loaded');
        return response.json();
      })
      .finally(() => {
        cartRequest = null;
      });

    return cartRequest;
  };

  const getRecommendations = async (productId) => {
    if (recommendationCache.has(productId)) return recommendationCache.get(productId);

    const request = fetch(`/recommendations/products.json?product_id=${productId}&limit=10`)
      .then((response) => {
        if (!response.ok) throw new Error('Recommendations could not be loaded');
        return response.json();
      })
      .then((data) => data.products || [])
      .catch((error) => {
        recommendationCache.delete(productId);
        throw error;
      });

    recommendationCache.set(productId, request);
    return request;
  };
  const getCartDrawer = () => document.querySelector('cart-drawer');
  const isMobile = () => window.innerWidth < MOBILE_BREAKPOINT;

  function createProductHTML(product) {
    const { compare_at_price, price, variants, options, url, featured_image, title, vendor } = product;
    const discount = Math.round(((compare_at_price - price) / compare_at_price) * 100);
    const hasDiscount = compare_at_price > 0;
    const first = variants[0];
    const colorOption = options.find(o => o.name.toLowerCase() === 'color');
    const colorValue = colorOption ? first.options[options.indexOf(colorOption)] : first.option2 || first.option1;
    const circleColor = handleize(colorValue);
    const sizeKind = first.option1.toLowerCase().includes('meses') ? 'M' : first.option1.toLowerCase().includes('años') ? 'A' : '';
    const isUnique = first.option1.toLowerCase().includes('talla');

    return `
      <div class="app-cart-reco-item">
        <a href="${url}">
          <img
            src="${getCardImageUrl(featured_image, 240)}"
            srcset="${getCardImageUrl(featured_image, 144)} 144w, ${getCardImageUrl(featured_image, 180)} 180w, ${getCardImageUrl(featured_image, 240)} 240w"
            sizes="(max-width: 989px) 72px, 90px"
            alt="${title}"
            loading="lazy"
            decoding="async"
            width="400"
            height="500"
          >
        </a>
        <div class="app-cart-reco-item__info">
          <p class="app-cart-reco-item__vendor">${vendor}</p>
          <a href="${url}" class="app-cart-reco-item__title">${title}</a>
          <div class="product-option">
            <dd>
              <span class="circle" style="background-color: var(--color-${circleColor})">&nbsp;</span>
              ${colorValue} / ${first.option1}
            </dd>
          </div>
          <span class="reco-subtitle">+ AGREGAR AL CARRO</span>
          <div class="app-cart-reco-item__variants">
            ${variants.map(v => `<span class="reco-variant" id="${v.id}" ${!v.available ? 'disabled' : ''}>${isUnique ? 'Talla Única' : v.option1.split(" ")[0] + sizeKind}</span>`).join('')}
          </div>
        </div>
        <div class="app-cart-reco-item__price">
          <div class="price-wrapper">
            ${hasDiscount ? `<span class="compare-price">$${(compare_at_price / 100).toLocaleString('es-CL')}</span>` : ''}
            <span class="final-price ${hasDiscount ? 'has-discount' : ''}">$${(price / 100).toLocaleString('es-CL')}</span>
          </div>
          ${hasDiscount ? `<div class="badge-offer">-${discount}%</div>` : ''}
        </div>
      </div>`;
  }

  function render(products, cart, list, sourceVendor) {
    if (!list) return;

    const cartIds = cart.items.map(i => i.product_id);
    let filtered = products.filter(p => !cartIds.includes(p.id));
    if (sourceVendor) filtered = filtered.filter(p => p.vendor === sourceVendor);
    filtered = filtered.slice(0, 5);

    list.innerHTML = filtered.length
      ? filtered.map(createProductHTML).join('')
      : '<div class="app-cart-sidebar__loading">No hay recomendaciones</div>';
  }

  async function updateRecommendations(cart = null) {
    const requestId = ++recommendationRequestId;
    const targetId = isMobile() ? 'mobile-bar' : 'desktop-bar';
    const sidebar = document.getElementById(targetId);
    const list = sidebar?.querySelector('.app-cart-sidebar__list');

    try {
      if (!cart || !Array.isArray(cart.items)) cart = await getCart();
      if (requestId !== recommendationRequestId) return;

      if (!cart.items.length) {
        if (sidebar) sidebar.style.display = 'none';
        return;
      }

      if (sidebar) sidebar.style.display = '';
      if (list) list.innerHTML = '<div class="skeleton-loader">&nbsp;</div>'.repeat(5);

      const products = await getRecommendations(cart.items[0].product_id);
      if (requestId !== recommendationRequestId) return;

      render(products, cart, list, cart.items[0].vendor);
      setTimeout(updateCustomScrollbars, 100);
    } catch (error) {
      if (requestId !== recommendationRequestId) return;
      console.error('Error loading cart recommendations:', error);
      if (list) list.innerHTML = '<div class="app-cart-sidebar__loading">No hay recomendaciones</div>';
    }
  }

  function initListSwitcher() {
    const sidebar = document.getElementById('mobile-bar');
    if (!sidebar) return;

    const bagsList = sidebar.querySelector('.app-cart-sidebar__bags-list');
    const recoList = sidebar.querySelector('.app-cart-sidebar__list');
    if (!bagsList || !recoList) return;

    bagsList.style.display = 'flex';
    recoList.style.display = 'none';
    document.querySelector('.list-switch-btn[data-list="bags"]')?.classList.add('active');
  }

  window.switchList = function (listType, btn) {
    const sidebar = document.getElementById('mobile-bar');
    if (!sidebar) return;

    const bagsList = sidebar.querySelector('.app-cart-sidebar__bags-list');
    const recoList = sidebar.querySelector('.app-cart-sidebar__list');
    if (!bagsList || !recoList) return;

    document.querySelectorAll('.list-switch-btn').forEach(b => b.classList.remove('active'));
    btn?.classList.add('active');

    bagsList.style.display = listType === 'bags' ? 'flex' : 'none';
    recoList.style.display = listType === 'recommendations' ? 'flex' : 'none';
    setTimeout(updateCustomScrollbars, 50);
  };

  const cartDrawer = getCartDrawer();
  if (cartDrawer) {
    new MutationObserver(mutations => {
      if (mutations.some(m => m.type === 'attributes' && m.attributeName === 'class' && m.target.classList.contains('active'))) {
        clearTimeout(cartDrawerOpenTimer);
        cartDrawerOpenTimer = setTimeout(() => {
          updateRecommendations();
          initListSwitcher();
          setTimeout(updateCustomScrollbars, 200);
        }, 100);
      }
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
      if (getCartDrawer()?.classList.contains('active')) {
        setTimeout(() => updateRecommendations(event.cartData), 150);
      }
    });
  }

  // Event listeners específicos para las flechas del carrusel de bolsas
  document.querySelectorAll('.app-cart-sidebar__bags .arrow.left').forEach(arrow => {
    arrow.addEventListener('click', () => {
      const bagsContainer = arrow.closest('.app-cart-sidebar__bags');
      scrollBagsCarousel(-0.3, bagsContainer);
    });
  });

  document.querySelectorAll('.app-cart-sidebar__bags .arrow.right').forEach(arrow => {
    arrow.addEventListener('click', () => {
      const bagsContainer = arrow.closest('.app-cart-sidebar__bags');
      scrollBagsCarousel(0.3, bagsContainer);
    });
  });

  document.addEventListener('click', async (e) => {
    const giftToggle = e.target.closest('.gift-unlock__toggle');
    if (giftToggle && isMobile()) {
      e.preventDefault();
      const root = giftToggle.closest('.gift-unlock');
      if (!root) return;
      const open = root.classList.toggle('is-open');
      giftToggle.setAttribute('aria-expanded', String(open));
      return;
    }

    const bagPrice = e.target.closest('.bag-price');
    if (bagPrice) {
      e.preventDefault();
      if (await addToCartAndRefresh(bagPrice.dataset.variantId)) await updateRecommendations();
      return;
    }

    const variant = e.target.closest('.reco-variant');
    if (variant && !variant.hasAttribute('disabled')) {
      e.preventDefault();
      const giftItem = variant.closest('.gift-unlock__item');
      const recoItem = variant.closest('.app-cart-reco-item');
      const parent = giftItem || recoItem;
      parent?.querySelectorAll('.reco-variant').forEach((v) => v.removeAttribute('active'));
      variant.setAttribute('active', '');
      if (await addToCartAndRefresh(variant.id)) {
        if (!giftItem) await updateRecommendations();
      }
      return;
    }

    const btn = e.target.closest('.app-cart-reco-item__add');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    if (await addToCartAndRefresh(btn.dataset.variantId)) await updateRecommendations(await getCart());
    btn.disabled = false;
  });

  window.addEventListener('resize', () => updateCustomScrollbars(1));
  window.addEventListener('orientationchange', () => setTimeout(() => updateCustomScrollbars(2), 500));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initListSwitcher();
      updateCustomScrollbars(2);
    });
  } else {
    initListSwitcher();
    updateCustomScrollbars(2);
  }
})();

// ============================================
// Collection Navigation Tracking for Breadcrumbs
// ============================================
(() => {
  // Track product clicks from collection pages
  document.addEventListener('click', (e) => {
    const productLink = e.target.closest('.card-product a[href*="/products/"]');

    if (productLink) {
      // Check if we're on a collection page
      const isCollectionPage = window.location.pathname.includes('/collections/');

      if (isCollectionPage) {
        // Extract collection handle from URL
        const pathParts = window.location.pathname.split('/');
        const collectionIndex = pathParts.indexOf('collections');

        if (collectionIndex !== -1 && pathParts[collectionIndex + 1]) {
          const collectionHandle = pathParts[collectionIndex + 1];

          // Get collection title from page (try multiple selectors)
          let collectionTitle = '';

          // Try to get from collection banner heading
          const bannerHeading = document.querySelector('.collection-hero__title, .collection__title, h1');
          if (bannerHeading) {
            collectionTitle = bannerHeading.textContent.trim();
          }

          // Fallback: format handle as title
          if (!collectionTitle) {
            collectionTitle = collectionHandle
              .split('-')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ');
          }

          // Store in sessionStorage
          sessionStorage.setItem('productFromCollection', 'true');
          sessionStorage.setItem('collectionHandle', collectionHandle);
          sessionStorage.setItem('collectionTitle', collectionTitle);
        }
      } else {
        // Clear collection tracking if not on a collection page
        sessionStorage.removeItem('productFromCollection');
        sessionStorage.removeItem('collectionHandle');
        sessionStorage.removeItem('collectionTitle');
      }
    }
  });

  // Clear collection tracking when navigating to home
  if (window.location.pathname === '/' ||
    window.location.pathname === '/index' ||
    window.location.pathname.includes('/index')) {
    sessionStorage.removeItem('productFromCollection');
    sessionStorage.removeItem('collectionHandle');
    sessionStorage.removeItem('collectionTitle');
  }
})();

// Judge.me badge text formatter
(function () {
  const badgeSelector = '.jdgm-prev-badge__text';
  const pendingBadges = new Set();
  let badgeWorkScheduled = false;

  const runWhenIdle = window.requestIdleCallback
    ? (callback) => window.requestIdleCallback(callback, { timeout: 500 })
    : (callback) => setTimeout(() => callback({ didTimeout: true, timeRemaining: () => 0 }), 16);

  function formatBadgeText(textEl) {
    const badge = textEl.closest('.jdgm-prev-badge');
    if (!badge) return;
    const count = parseInt(badge.dataset.numberOfReviews, 10);
    if (Number.isNaN(count) || count === 0) {
      if (textEl.style.display !== 'none') {
        textEl.style.display = 'none';
      }
    } else {
      const newText = `(${count})`;
      if (textEl.textContent !== newText) {
        textEl.textContent = newText;
      }
      if (textEl.style.display !== '') {
        textEl.style.display = '';
      }
    }
  }

  function scheduleBadgeWork() {
    if (badgeWorkScheduled || pendingBadges.size === 0) return;
    badgeWorkScheduled = true;
    runWhenIdle(processBadgeQueue);
  }

  function processBadgeQueue(deadline) {
    badgeWorkScheduled = false;
    let processed = 0;

    for (const textEl of pendingBadges) {
      pendingBadges.delete(textEl);
      if (textEl.isConnected) formatBadgeText(textEl);
      processed += 1;

      if (processed >= 40 || (!deadline.didTimeout && deadline.timeRemaining() < 2)) break;
    }

    scheduleBadgeWork();
  }

  function queueBadges(root) {
    if (!root) return;
    if (root.matches?.(badgeSelector)) pendingBadges.add(root);
    root.querySelectorAll?.(badgeSelector).forEach((badge) => pendingBadges.add(badge));
    scheduleBadgeWork();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => queueBadges(document), { once: true });
  } else {
    queueBadges(document);
  }

  const targetNode = document.querySelector('main') || document.body;
  if (!targetNode) return;

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) queueBadges(node);
      });
    }
  });

  observer.observe(targetNode, {
    childList: true,
    subtree: true
  });

  document.addEventListener('shopify:section:load', (event) => queueBadges(event.target));
})();

/* Flash sale countdown */
(function () {
  const pad = n => String(n).padStart(2, '0');
  const countdowns = new Map();
  let countdownInterval = null;

  /* Lucide clock-12, clock-1 ... clock-11 hand paths (https://lucide.dev), in clockwise order
     starting at 12 o'clock, used to animate .price-countdown-clock__hand one step per second. */
  const CLOCK_HAND_PATHS = [
    'M12 6v6', 'M12 6v6l2-4', 'M12 6v6l4-2', 'M12 6v6h4', 'M12 6v6l4 2', 'M12 6v6l2 4',
    'M12 6v10', 'M12 6v6l-2 4', 'M12 6v6l-4 2', 'M12 6v6H8', 'M12 6v6l-4-2', 'M12 6v6l-2-4'
  ];

  function formatCountdown(ms) {
    if (ms <= 0) return null;
    const days    = Math.floor(ms / 86400000);
    const hours   = Math.floor((ms % 86400000) / 3600000);
    const minutes = Math.floor((ms % 3600000) / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);

    const time = hours > 0
      ? `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
      : `${pad(minutes)}:${pad(seconds)}`;

    if (days > 0) return `${days}d ${time}`;
    return time;
  }

  function registerCountdowns(root) {
    if (!root) return;

    const elements = [];
    if (root.matches?.('[data-expiration]')) elements.push(root);
    root.querySelectorAll?.('[data-expiration]').forEach((element) => elements.push(element));

    for (const element of elements) {
      if (countdowns.has(element)) continue;

      const expiration = Number.parseInt(element.dataset.expiration, 10) * 1000;
      const timer = element.querySelector('.sale-countdown__timer');
      if (!Number.isFinite(expiration) || !timer) continue;

      countdowns.set(element, {
        expiration,
        timer,
        hand: element.querySelector('.price-countdown-clock__hand')
      });
    }
  }

  function stopCountdowns() {
    if (countdownInterval === null) return;
    clearInterval(countdownInterval);
    countdownInterval = null;
  }

  function updateCountdowns() {
    const now = Date.now();
    const clockFrame = Math.floor(now / 1000) % CLOCK_HAND_PATHS.length;

    for (const [element, countdown] of countdowns) {
      if (!element.isConnected) {
        countdowns.delete(element);
        continue;
      }

      const formatted = formatCountdown(countdown.expiration - now);
      if (!formatted) {
        element.style.display = 'none';
        countdowns.delete(element);
      } else {
        if (countdown.timer.textContent !== formatted) countdown.timer.textContent = formatted;
        if (countdown.hand?.getAttribute('d') !== CLOCK_HAND_PATHS[clockFrame]) {
          countdown.hand.setAttribute('d', CLOCK_HAND_PATHS[clockFrame]);
        }
      }
    }

    if (countdowns.size === 0) stopCountdowns();
  }

  function startCountdowns() {
    if (document.hidden || countdowns.size === 0 || countdownInterval !== null) return;
    updateCountdowns();
    countdownInterval = setInterval(updateCountdowns, 1000);
  }

  function initializeCountdowns(root = document) {
    registerCountdowns(root);
    startCountdowns();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCountdowns(), { once: true });
  } else {
    initializeCountdowns();
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopCountdowns();
    } else {
      initializeCountdowns();
    }
  });

  document.addEventListener('shopify:section:load', (event) => initializeCountdowns(event.target));

  const productGridContainer = document.getElementById('ProductGridContainer');
  if (productGridContainer) {
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) registerCountdowns(node);
        });
      }
      startCountdowns();
    }).observe(productGridContainer, { childList: true, subtree: true });
  }
})();
